// extracted by mini-css-extract-plugin
export default {"AccessRestrictedWrap":"MsSxV9oXSU9_Ycp60k5G","common_bganimation":"U69HfpH8mKzmPM3vabVQ"};